import {
  AnalyticsEvent,
  AnalyticsEventErrorProperties,
  AnalyticsEventInteractionProperties,
} from './types';
import { enableGoogleAnalytics } from './googleAnalytics';
import {
  enableMixpanel,
  initializeMixpanel,
  trackEventMixpanel,
} from './mixpanel';

/**
 * Google analytics is not initialized separately here, but implicitly done when
 * loading firebase.
 */
export const initializeAnalytics = initializeMixpanel;

export const enableAnalytics = (): void => {
  enableGoogleAnalytics();
  enableMixpanel();
};

/*
 * Should not be used directly, should be used via useTracking hook to include
 * context based information automatically.
 * Currently this only tracks mixpanel. In the future use cases, if needed, we
 * can add google analytics tracking here as well.
 */
export const trackAnalyticsEvent = (event: AnalyticsEvent): void => {
  trackEventMixpanel({
    name: event.name,
    properties: {
      ...event.properties,
      ...event.superProperties,
    },
  });
};
export type {
  AnalyticsEvent,
  AnalyticsEventErrorProperties,
  AnalyticsEventInteractionProperties,
};
